import React, { useEffect, useState, useRef } from "react";
import {
  DndContext,
  useDraggable,
  useSensor,
  useSensors,
  PointerSensor,
} from "@dnd-kit/core";
import {
  Menu,
  Button,
  ColorPicker,
  Tooltip,
  Modal,
  TextInput,
  NumberInput,
  Radio,
  Checkbox,
  Table,
} from "@mantine/core";

import axios from "axios";

import "../Styles/Comp_CafeMap.css";

const { REACT_APP_ECLIPSE_API, REACT_APP_ECLIPSE_API_LOCAL } = process.env;

// ----------------------------------------------- Comp
// const Comp_Legend_PCZone = ({ cafename, setSelectedPCZone }) => {
//   const [DB_CafePCList_PCZone, setDB_CafePCZoneList] = useState([]);
//   const get_DB_CafePCZoneList = async (cafe) => {
//     console.log("load task 1 start");

//     await axios
//       //REACT_APP_ECLIPSE_API
//       .post(
//         `http://localhost:7000/get_eclipse_pos_cafepc_customlist__groupbyPCZone`,
//         {
//           cafe: cafename,
//         }
//       )
//       .then((res) => {
//         setDB_CafePCZoneList(res?.data);

//         console.log("get_DB_CafePCZoneList", res?.data);
//       });
//   };

//   const Total_PC = DB_CafePCList_PCZone?.reduce((acc, x) => {
//     return acc + (x?.total_pc || 0);
//   }, 0);

//   useEffect(() => {
//     get_DB_CafePCZoneList();
//   }, []);
//   return (
//     <div
//       style={{
//         backgroundColor: "black",
//         borderRadius: "1rem",
//         padding: "1rem",
//       }}
//     >
//       <b>PC Zone List</b>
//       <div style={{ color: "white" }}>{cafename}</div>
//       <br />
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           gap: 4,
//           alignItems: "left",
//         }}
//       >
//         {DB_CafePCList_PCZone?.map((x) => {
//           return (
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//               }}
//               onClick={() => {
//                 console.log("Clicked on PC Zone", x?.pczone_name);
//                 setSelectedPCZone(x?.pczone_name);
//               }}
//             >
//               <Button
//
//                 size="xs"
//                 style={{
//                   backgroundColor: x?.custom_bgcolor,
//                 }}
//               >
//                 {x?.pczone_name}
//               </Button>
//               <div
//                 style={{
//                   color: "white",
//                   width: "1rem",
//                   marginLeft: "1rem",
//                   textAlign: "right",
//                 }}
//               >
//                 {x?.total_pc}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//       <br />
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "row",
//           justifyContent: "space-between",
//         }}
//       >
//         <div style={{ color: "white" }}>Total PC = </div>
//         <div style={{ color: "white", marginLeft: 4 }}> {Total_PC}</div>
//       </div>
//     </div>
//   );
// };
const Comp_Legend_PCHW = ({ cafename, selectedPCHW, setSelectedPCHW }) => {
  const [DB_CafePCHWList_pczone_name, setDB_CafePCHWList_pczone_name] =
    useState([]);
  const [DB_CafePCHWList_GPU_Name, setDB_CafePCHWList_GPU_Name] = useState([]);
  const [DB_CafePCHWList_CPU_Name, setDB_CafePCHWList_CPU_Name] = useState([]);
  const [DB_CafePCHWList_RAM_Capacity, setDB_CafePCHWList_RAM_Capacity] =
    useState([]);
  const [DB_CafePCHW_MON_Manufacturer, setDB_CafePCHW_MON_Manufacturer] =
    useState([]);
  const [DB_CafePCHWList_mon_fps, setDB_CafePCHWList_mon_fps] = useState([]);
  const [DB_CafePCHWList_NIC_Speed, setDB_CafePCHWList_NIC_Speed] = useState(
    [],
  );
  const [DB_CafePCHWList_OfflineDay, setDB_CafePCHWList_OfflineDay] = useState(
    [],
  );
  const [DB_CafePCHWList_VT_ON, setDB_CafePCHWList_VT_ON] = useState([]);
  const [
    DB_CafePCHWList_PC_StartUpTime_Sec,
    setDB_CafePCHWList_PC_StartUpTime_Sec,
  ] = useState([]);
  const [DB_CafePCHWList_MOBO_Product, setDB_CafePCHWList_MOBO_Product] =
    useState([]);

  const [opened_Modal_HardwareConfig, setOpened_Modal_HardwareConfig] =
    useState(false);
  const [DB_CafePCListLive, setDB_CafePCListLive] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [newHardwareInputs, setNewHardwareInputs] = useState({});
  const [searchText, setSearchText] = useState("");

  const get_DB_CafePCHWList = async (cafe, groupby) => {
    console.log("load task 1 start");

    await axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/get_eclipse_pos_cafepc_customlist__groupbyPCHW`,
        {
          cafe,
          groupby,
        },
      )
      .then((res) => {
        setDB_CafePCHWList_pczone_name(res?.data?.[0]);
        setDB_CafePCHWList_GPU_Name(res?.data?.[1]);
        setDB_CafePCHWList_CPU_Name(res?.data?.[2]);
        setDB_CafePCHWList_RAM_Capacity(res?.data?.[3]);
        setDB_CafePCHW_MON_Manufacturer(res?.data?.[4]);
        setDB_CafePCHWList_mon_fps(res?.data?.[5]);
        setDB_CafePCHWList_NIC_Speed(res?.data?.[6]);

        setDB_CafePCHWList_OfflineDay(res?.data?.[7]);
        setDB_CafePCHWList_VT_ON(res?.data?.[8]);
        setDB_CafePCHWList_PC_StartUpTime_Sec(res?.data?.[9]);
        setDB_CafePCHWList_MOBO_Product(res?.data?.[10]);

        console.log("get_DB_CafePCHWList", res?.data);
      });
  };

  const get_DB_CafePCListLive = async () => {
    console.log("Fetching cafe PC list live data");

    await axios
      .post(
        `${REACT_APP_ECLIPSE_API}/get_eclipse_awesome_pos_join_cafe_pc_list_live`,
        {},
      )
      .then((res) => {
        setDB_CafePCListLive(res?.data);
        console.log("get_DB_CafePCListLive", res?.data);
      })
      .catch((err) => {
        console.error("Error fetching cafe PC list live:", err);
      });
  };

  const formatDateWithTimeAgo = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;

    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    const minutes = diffMinutes % 60;
    const hours = diffHours % 24;
    const days = diffDays;

    const formattedDate = date.toISOString().slice(0, 19).replace("T", " ");
    const timeAgo = `${days}d:${hours}h:${minutes}m ago`;

    return `${formattedDate} (${timeAgo})`;
  };

  const formatHardwareName = (name) => {
    if (!name) return name;

    const trimmed = name.trim();

    if (trimmed.includes("|")) {
      // Normalize spacing around pipe: split by |, trim each part, rejoin with " | "
      const parts = trimmed.split("|").map((part) => part.trim());
      return parts.join(" | ");
    } else {
      // No pipe present, add it at the front with proper spacing: " | name"
      return ` | ${trimmed}`;
    }
  };

  const update_DB_ConfigHardware = async (id, ori_hw_name, new_hw_name) => {
    const formattedNewHwName = formatHardwareName(new_hw_name);

    console.log("Updating hardware config", {
      id,
      ori_hw_name,
      new_hw_name: formattedNewHwName,
    });

    await axios
      .post(
        `${REACT_APP_ECLIPSE_API}/update_eclipse_awesome_pos_config_hardware`,
        {
          id,
          ori_hw_name,
          new_hw_name: formattedNewHwName,
        },
      )
      .then((res) => {
        console.log("update_DB_ConfigHardware", res?.data);
        alert("Updated successfully!");
        get_DB_CafePCListLive();
        setEditingRow(null);
        setEditedData({});
      })
      .catch((err) => {
        console.error("Error updating hardware config:", err);
        alert("Error updating hardware config");
      });
  };

  const handleEdit = (rowIndex, row) => {
    setEditingRow(rowIndex);
    setEditedData({
      id: row.id,
      hardware_name: row.hardware_name,
      new_hw_name: row.new_hw_name,
    });
  };

  const handleInputChange = (field, value) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const add_DB_ConfigHardware = async (ori_hw_name, new_hw_name) => {
    const formattedNewHwName = formatHardwareName(new_hw_name);

    console.log("Adding new hardware config", {
      ori_hw_name,
      new_hw_name: formattedNewHwName,
    });

    await axios
      .post(
        `${REACT_APP_ECLIPSE_API}/add_eclipse_awesome_pos_config_hardware`,
        {
          ori_hw_name,
          new_hw_name: formattedNewHwName,
        },
      )
      .then((res) => {
        console.log("add_DB_ConfigHardware", res?.data);
        alert("Added successfully!");
        get_DB_CafePCListLive();
        setNewHardwareInputs({});
      })
      .catch((err) => {
        console.error("Error adding hardware config:", err);
        alert("Error adding hardware config");
      });
  };

  const handleNewHardwareInputChange = (rowIndex, value) => {
    setNewHardwareInputs((prev) => ({
      ...prev,
      [rowIndex]: value,
    }));
  };

  const handleAddNew = (rowIndex, row) => {
    console.log({ rowIndex, row });
    const newHwName = newHardwareInputs[rowIndex];

    if (!newHwName || newHwName.trim() === "") {
      alert("Please enter a new hardware name");
      return;
    }
    add_DB_ConfigHardware(row?.hardware_name || "", newHwName);
  };

  const handleUpdate = (rowIndex, row) => {
    console.log({ rowIndex, row });
    const newHwName = editedData.new_hw_name;

    if (!newHwName || newHwName.trim() === "") {
      alert("Please enter a new hardware name");
      return;
    }
    update_DB_ConfigHardware(
      editedData.id,
      row?.hardware_name || "",
      newHwName,
    );
  };

  const [opened_Modal_PCZoneEdit, setOpened_Modal_PCZoneEdit] = useState(false);
  const [newPCZoneName, setNewPCZoneName] = useState("");
  const [selected_pczone_name, setSelected_pczone_name] = useState("");

  const Total_PC = DB_CafePCHWList_pczone_name?.reduce((acc, x) => {
    return acc + (x?.total_pc || 0);
  }, 0);

  useEffect(() => {
    get_DB_CafePCHWList(cafename);

    console.log("get_DB_CafePCHardwareList", cafename);
  }, [cafename]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
        alignItems: "left",
        // width: "100%",
        backgroundColor: "black",
        borderRadius: "1rem",
        padding: "1rem",
      }}
    >
      <Modal
        opened={opened_Modal_PCZoneEdit}
        onClose={() => setOpened_Modal_PCZoneEdit(false)}
        title="Edit PC Zone Name"
      >
        <h4>
          Notis: After change the PC Zone Name will need to wait PC usage log
          fetch back on backend only will have changes
        </h4>
        <br />
        <b>{`Current Cafe Name = ${cafename}`}</b>
        <br />
        <b>{`Current PC Zone Name = ${selected_pczone_name}`}</b>
        <br />
        <b>{`New PC Zone Name = ${newPCZoneName}`}</b>
        <br />
        <TextInput
          value={newPCZoneName}
          onChange={(event) => setNewPCZoneName(event.currentTarget.value)}
        />
        <br />
        <Button
          color="red"
          onClick={() => {
            alert("uodated");
          }}
        >
          Update Pc Zone Name
        </Button>
      </Modal>

      <Modal
        opened={opened_Modal_HardwareConfig}
        onClose={() => setOpened_Modal_HardwareConfig(false)}
        title="✏️Manage Hardware Name"
        size="100%"
      >
        <TextInput
          placeholder="Search hardware name or new hardware name (min 3 characters)"
          value={searchText}
          onChange={(e) => setSearchText(e.currentTarget.value)}
          style={{ marginBottom: "1rem" }}
          styles={{
            input: {
              backgroundColor: "#2c2c2c",
              color: "#e0e0e0",
              border: "1px solid #555",
            },
          }}
        />
        <br />
        <b>💡 | symbol use to separate brand and name</b>
        <br />
        <b>ie. TitanArmy | XXXX-PLUS </b>
        <br />
        <br />
        <div style={{ maxHeight: "600px", overflowY: "auto" }}>
          <Table
            striped
            highlightOnHover
            withTableBorder
            withColumnBorders
            style={{
              backgroundColor: "#2c2c2c",
              color: "#e0e0e0",
            }}
          >
            <Table.Thead style={{ backgroundColor: "#1a1a1a" }}>
              <Table.Tr>
                <Table.Th style={{ color: "#ffffff", fontWeight: "bold" }}>
                  id
                </Table.Th>
                <Table.Th style={{ color: "#ffffff", fontWeight: "bold" }}>
                  hardware name
                </Table.Th>
                <Table.Th style={{ color: "#ffffff", fontWeight: "bold" }}>
                  new hardware name
                </Table.Th>
                <Table.Th style={{ color: "#ffffff", fontWeight: "bold" }}>
                  edit_dt
                </Table.Th>
                {/* <Table.Th style={{ color: "#ffffff", fontWeight: "bold" }}>
                  Actions
                </Table.Th> */}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {DB_CafePCListLive?.filter((row) => {
                // Only filter if search text is more than 3 characters
                if (searchText.length > 3) {
                  const searchLower = searchText.toLowerCase();
                  const hardwareName = (row?.hardware_name || "").toLowerCase();
                  const newHwName = (row?.new_hw_name || "").toLowerCase();
                  return (
                    hardwareName.includes(searchLower) ||
                    newHwName.includes(searchLower)
                  );
                }
                return true;
              })?.map((row, rowIndex) => (
                <Table.Tr
                  key={rowIndex}
                  style={{
                    backgroundColor: rowIndex % 2 === 0 ? "#2c2c2c" : "#383838",
                  }}
                >
                  <Table.Td style={{ color: "#e0e0e0" }}>
                    {row?.id ?? ""}
                  </Table.Td>
                  <Table.Td style={{ color: "#e0e0e0" }}>
                    {row?.hardware_name ?? ""}
                  </Table.Td>
                  <Table.Td style={{ color: "#e0e0e0" }}>
                    {!row?.new_hw_name || row?.new_hw_name === "" ? (
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                        }}
                      >
                        <TextInput
                          placeholder="Enter new hardware name"
                          value={newHardwareInputs[rowIndex] || ""}
                          onChange={(e) =>
                            handleNewHardwareInputChange(
                              rowIndex,
                              e.currentTarget.value,
                            )
                          }
                          styles={{
                            input: {
                              backgroundColor: "#1a1a1a",
                              color: "#e0e0e0",
                              border: "1px solid #555",
                            },
                          }}
                        />
                        <Button
                          size="xs"
                          color="lime"
                          onClick={() => handleAddNew(rowIndex, row)}
                        >
                          Add New
                        </Button>
                      </div>
                    ) : editingRow === rowIndex ? (
                      <div>
                        <TextInput
                          value={editedData.new_hw_name ?? ""}
                          onChange={(e) =>
                            handleInputChange(
                              "new_hw_name",
                              e.currentTarget.value,
                            )
                          }
                          styles={{
                            input: {
                              backgroundColor: "#1a1a1a",
                              color: "#e0e0e0",
                              border: "1px solid #555",
                            },
                          }}
                        />
                        <Button
                          size="xs"
                          color="lime"
                          onClick={() => handleUpdate(rowIndex, row)}
                        >
                          Update
                        </Button>
                      </div>
                    ) : (
                      <div className="CM_Flex_Row">
                        <div>{row?.new_hw_name}</div>
                        <Button
                          size="xs"
                          color="blue"
                          variant="subtle"
                          onClick={() => handleEdit(rowIndex, row)}
                        >
                          Edit
                        </Button>
                      </div>
                    )}
                  </Table.Td>
                  <Table.Td style={{ color: "#e0e0e0" }}>
                    {formatDateWithTimeAgo(row?.edit_dt)}
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </div>
      </Modal>

      <div className="CM_Flex_Row">
        <h3>{`Hardware List ( ${Total_PC} PC ) `} </h3>

        {selectedPCHW !== "" ? (
          <Button
            size="xs"
            color="lime"
            variant="subtle"
            onClick={() => {
              setSelectedPCHW("");
            }}
          >
            Clear
          </Button>
        ) : null}
        <Button
          size="xs"
          color="orange"
          variant="subtle"
          onClick={() => {
            get_DB_CafePCListLive();
            setOpened_Modal_HardwareConfig(true);
          }}
        >
          ✏️Manage Hardware Name
        </Button>
      </div>

      <div className="CM_Grid_HarwareList_CafeMap">
        <div>
          {DB_CafePCHWList_pczone_name?.map((x, i) => {
            return (
              <div key={i}>
                <div
                  style={{
                    cursor: "pointer",
                    // width: "100%",
                    display: "grid",
                    gridTemplateColumns: "3fr 1fr 1fr",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      backgroundColor:
                        selectedPCHW == x?.pczone_name ? x?.custom_bgcolor : "",
                      color:
                        selectedPCHW !== x?.pczone_name
                          ? x?.custom_bgcolor
                          : "white",
                      borderRadius: "4px",
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "0.5rem",
                    }}
                    onClick={() => {
                      setSelectedPCHW(x?.pczone_name);
                    }}
                  >
                    {x?.pczone_name}
                  </div>
                  <div style={{ textAlign: "right" }}>{x?.total_pc}</div>
                  <Tooltip label="Edit PC Zone Name">
                    <Button
                      color="red"
                      variant="subtle"
                      onClick={() => {
                        setSelected_pczone_name(x?.pczone_name);
                        setOpened_Modal_PCZoneEdit(true);
                      }}
                    >
                      📝
                    </Button>
                  </Tooltip>
                </div>
              </div>
            );
          })}
        </div>
        <div>
          {DB_CafePCHWList_CPU_Name?.map((x, i) => {
            return (
              <div
                key={i}
                style={{
                  cursor: "pointer",
                  // width: "100%",
                  display: "grid",
                  gridTemplateColumns: "5fr 1fr ",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor: selectedPCHW == x?.CPU_Name ? "gray" : "",
                    borderRadius: "4px",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    setSelectedPCHW(x?.CPU_Name);
                  }}
                >
                  {x?.CPU_Name}
                </div>
                <div style={{ marginLeft: "5px" }}>{x?.total_pc}</div>
              </div>
            );
          })}
        </div>
        <div>
          {DB_CafePCHWList_RAM_Capacity?.map((x, i) => {
            return (
              <div
                key={i}
                style={{
                  cursor: "pointer",
                  // width: "100%",
                  display: "grid",
                  gridTemplateColumns: "5fr 1fr ",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      selectedPCHW == x?.RAM_Capacity ? "gray" : "",
                    borderRadius: "4px",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    setSelectedPCHW(x?.RAM_Capacity);
                  }}
                >
                  {`${x?.RAM_Capacity?.split(",")?.[0] / 1024}GB (${
                    x?.RAM_Capacity?.split(",")?.[1] / 1024
                  }+${x?.RAM_Capacity?.split(",")?.[2] / 1024})`}
                </div>
                <div>{x?.total_pc}</div>
              </div>
            );
          })}
        </div>
        <div>
          {DB_CafePCHWList_GPU_Name?.map((x, i) => {
            return (
              <div
                key={i}
                style={{
                  cursor: "pointer",
                  // width: "100%",
                  display: "grid",
                  gridTemplateColumns: "5fr 1fr ",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor: selectedPCHW == x?.GPU_Name ? "gray" : "",
                    borderRadius: "4px",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    setSelectedPCHW(x?.GPU_Name);
                  }}
                >
                  {x?.GPU_Name}
                </div>
                <div>{x?.total_pc}</div>
              </div>
            );
          })}
        </div>
        <div>
          {DB_CafePCHW_MON_Manufacturer?.map((x, i) => {
            return (
              <div
                key={i}
                style={{
                  cursor: "pointer",
                  // width: "100%",
                  display: "grid",
                  gridTemplateColumns: "5fr 1fr ",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      selectedPCHW == x?.MON_Manufacturer ? "gray" : "",
                    borderRadius: "4px",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    setSelectedPCHW(x?.MON_Manufacturer);
                  }}
                >
                  {x?.MON_Manufacturer}
                </div>
                <div>{x?.total_pc}</div>
              </div>
            );
          })}
        </div>
        <div>
          {DB_CafePCHWList_mon_fps?.map((x, i) => {
            return (
              <div
                key={i}
                style={{
                  cursor: "pointer",
                  // width: "100%",
                  display: "grid",
                  gridTemplateColumns: "5fr 1fr ",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor: selectedPCHW == x?.mon_fps ? "gray" : "",
                    borderRadius: "4px",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    setSelectedPCHW(x?.mon_fps);
                  }}
                >
                  {x?.mon_fps}
                </div>
                <div>{x?.total_pc}</div>
              </div>
            );
          })}
        </div>
        {/* <div>
          {DB_CafePCHWList_NIC_Speed?.map((x, i) => {
            return (
              <div
                key={i}
                style={{
                  cursor: "pointer",
                  // width: "100%",
                  display: "grid",
                  gridTemplateColumns: "5fr 1fr ",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor: selectedPCHW == x?.NIC_Speed ? "gray" : "",
                    borderRadius: "4px",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    setSelectedPCHW(x?.NIC_Speed);
                  }}
                >
                  {x?.NIC_Speed}
                </div>
                <div>{x?.total_pc}</div>
              </div>
            );
          })}
        </div>
        <div>
          {DB_CafePCHWList_OfflineDay?.map((x, i) => {
            return (
              <div
                key={i}
                style={{
                  cursor: "pointer",
                  // width: "100%",
                  display: "grid",
                  gridTemplateColumns: "5fr 1fr ",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      selectedPCHW === x?.Offline_Day ? "gray" : "",
                    borderRadius: "4px",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    setSelectedPCHW(x?.Offline_Day);
                  }}
                >
                  {`${x?.Offline_Day} Day Off`}
                </div>
                <div style={{ marginLeft: "5px" }}>{x?.total_pc}</div>
              </div>
            );
          })}
        </div>
        <div>
          {DB_CafePCHWList_VT_ON?.map((x, i) => {
            return (
              <div
                key={i}
                style={{
                  cursor: "pointer",
                  // width: "100%",
                  display: "grid",
                  gridTemplateColumns: "5fr 1fr ",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor: selectedPCHW === x?.VT_On ? "gray" : "",
                    borderRadius: "4px",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    setSelectedPCHW(x?.VT_On);
                  }}
                >
                  {`VT ON = ${x?.VT_On} `}
                </div>
                <div style={{ marginLeft: "5px" }}>{x?.total_pc}</div>
              </div>
            );
          })}
        </div>
        <div>
          {DB_CafePCHWList_PC_StartUpTime_Sec?.map((x, i) => {
            return (
              <div
                key={i}
                style={{
                  cursor: "pointer",
                  // width: "100%",
                  display: "grid",
                  gridTemplateColumns: "5fr 1fr ",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      selectedPCHW === x?.PC_StartUpTime_Sec ? "gray" : "",
                    borderRadius: "4px",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    setSelectedPCHW(x?.PC_StartUpTime_Sec);
                  }}
                >
                  {`Startup : ${x?.PC_StartUpTime_Sec}`}
                </div>
                <div style={{ marginLeft: "5px" }}>{x?.total_pc}</div>
              </div>
            );
          })}
        </div>
        <div>
          {DB_CafePCHWList_MOBO_Product?.map((x, i) => {
            return (
              <div
                key={i}
                style={{
                  cursor: "pointer",
                  // width: "100%",
                  display: "grid",
                  gridTemplateColumns: "5fr 1fr ",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      selectedPCHW === x?.MOBO_Product ? "gray" : "",
                    borderRadius: "4px",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    setSelectedPCHW(x?.MOBO_Product);
                  }}
                >
                  {`${x?.MOBO_Product}`}
                </div>
                <div style={{ marginLeft: "5px" }}>{x?.total_pc}</div>
              </div>
            );
          })}
        </div> */}
      </div>
    </div>
  );
};

const gridSize = 20;

function snapToGrid(x, y) {
  return {
    x: Math.round(x / gridSize) * gridSize,
    y: Math.round(y / gridSize) * gridSize,
  };
}

function DraggableBox({
  id,
  id_b,
  position,
  pc_name,
  custom_bgcolor,
  draggable,
  dlip,
  pczone_name,
  selectedPresentationCafe,
  w,
  h,
  x,
  y,
  pc_hide,
  setP_RequestReRender,
  C_SignalToCloseMenu,
  selectedPCZone,
  GPU_Name,
  CPU_Name,
  MON_Manufacturer,
  NIC_Speed,
  RAM_Capacity,
  mon_fps,
  selectedPCHW,
  showCoordinate,
  DB_ConfigHardwareList,

  Offline_Day,
  VT_On,
  PC_StartUpTime_Sec,
  MOBO_Product,

  DB_BoxList,
  // opened_Modal_PCInfo,
  // setOpened_Modal_PCInfo,
}) {
  // console.log(`label:${label},custom_bgcolor:${custom_bgcolor}`);

  const [isLoading2, setIsLoading2] = useState(false);
  const set_DB_Data_UpdateButtonPos_ByProps = async ({
    cafe,
    pc_name,
    x,
    y,
    w,
    h,
    custom_bgcolor,
    pc_hide,
  }) => {
    // setLoadTask1(0);
    // console.log("load task 1 start");
    // console.log("set_DB_Data_UpdateButtonPos_ByProps", {
    //   cafe,
    //   pc_name,
    //   x,
    //   y,
    //   w,
    //   h,
    //   custom_bgcolor,
    //   pc_hide,
    // });

    setIsLoading2(true);

    await axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/set_eclipse_pos_cafepc_customlist_fordnd__byprops`,
        {
          cafe,
          pc_name,
          x,
          y,
          w,
          h,
          custom_bgcolor,
          pc_hide,
        },
      )
      .then((res) => {
        // console.log("set_DB_Data_UpdateButtonPos_ByProps", res?.data);
        setP_RequestReRender(Math.random());
        setIsLoading2(false);
      });
  };

  const set_DB_Data_CafeBox_Def_gbColor = async (cafe, pc_name) => {
    // setLoadTask1(0);
    // console.log("load task 1 start");

    setIsLoading2(true);

    await axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/set_eclipse_pos_cafepc_cafebox_def_bgColor`,
        {
          cafe,
          pc_name,
        },
      )
      .then((res) => {
        // console.log("set_DB_Data_UpdateButtonPos_ByProps", res?.data);
        setP_RequestReRender(Math.random());
        setIsLoading2(false);
      });
  };

  const set_DB_Data_BoxName = async (cafe, pre_BoxName, new_BoxName) => {
    await axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/set_eclipse_pos__ultilityBoxName`, {
        cafe,
        pre_BoxName,
        new_BoxName,
      })
      .then((res) => {
        let result = res?.data;
        console.log("set_DB_Data_BoxName", result);
        if (result?.affectedRows > 0) {
          setP_RequestReRender(Math.random()); // reload map
          alert(`
          Added Successfully

          cafe = ${cafe}
          pre Box Name = ${pre_BoxName}
          new Box Name = ${new_BoxName}

          `);
        }
      });
  };

  const set_DB_Data_PCRemark = async (cafe, pc_name, pc_name_remark) => {
    console.log("xxx", { cafe, pc_name, pc_name_remark });
    await axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/set_eclipse_pos__ultilityPCRemark`, {
        cafe,
        pc_name,
        pc_name_remark,
      })
      .then((res) => {
        let result = res?.data;
        console.log("set_DB_Data_BoxName", result);
        if (result?.affectedRows > 0) {
          setP_RequestReRender(Math.random()); // reload map
          alert(`
          Update or Insert Successfully
          cafe = ${cafe}
          pc_name = ${pc_name}

          pre pc remark = ${get_CurrentPC_Remark(pc_name)}
          new pc remark = ${pc_name_remark}
          `);
        }
      });
  };

  const del_DB_Data_BoxName = async (cafe, boxName) => {
    // setLoadTask1(0);

    await axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/del_eclipse_pos__ultilityBoxName`, {
        cafe,
        boxName,
      })
      .then((res) => {
        let result = res?.data;
        console.log("set_DB_Data_BoxName", result);
        if (result?.affectedRows > 0) {
          setP_RequestReRender(Math.random()); // reload map
          alert(`
          Deleted Successfully

          cafe = ${cafe}
          Box Name = ${boxName} 

          `);
        }
      });
  };

  const highlightBGColor = (_custom_bgcolor) => {
    let result = "";

    if (selectedPCHW === "") {
      return _custom_bgcolor;
    }

    if (selectedPCHW === pczone_name && pczone_name !== "") {
      result = _custom_bgcolor;
    }

    if (selectedPCHW === GPU_Name && GPU_Name !== "") {
      result = _custom_bgcolor;
    }
    if (selectedPCHW === CPU_Name && CPU_Name !== "") {
      result = _custom_bgcolor;
    }
    if (selectedPCHW === RAM_Capacity && RAM_Capacity !== "") {
      result = _custom_bgcolor;
    }
    if (selectedPCHW === MON_Manufacturer && MON_Manufacturer !== "") {
      result = _custom_bgcolor;
    }
    if (selectedPCHW === mon_fps && mon_fps !== "") {
      result = _custom_bgcolor;
    }
    if (selectedPCHW === NIC_Speed && NIC_Speed !== "") {
      result = _custom_bgcolor;
    }

    if (selectedPCHW === Offline_Day && Offline_Day !== "") {
      result = _custom_bgcolor;
    }
    if (selectedPCHW === VT_On && VT_On !== "") {
      result = _custom_bgcolor;
    }
    if (selectedPCHW === PC_StartUpTime_Sec && PC_StartUpTime_Sec !== "") {
      result = _custom_bgcolor;
    }
    if (selectedPCHW === MOBO_Product && MOBO_Product !== "") {
      result = _custom_bgcolor;
    }

    return result;
  };

  const [selected_ChangePCName, setSelected_ChangePCName] = useState("");
  const [selected_PCRemark, setSelected_PCRemark] = useState("");
  const [selected_New_W, setSelected_New_W] = useState(0);
  const [selected_New_H, setSelected_New_H] = useState(0);
  const { attributes, listeners, setNodeRef, transform } = useDraggable({ id });

  const finalX = (position?.x || 0) + (transform?.x || 0);
  const finalY = (position?.y || 0) + (transform?.y || 0);

  const box_Style = {
    width: w,
    height: h,
    // backgroundColor: custom_bgcolor,
    backgroundColor: highlightBGColor(custom_bgcolor), //getNegativeColor(custom_bgcolor),
    position: "absolute",
    transform: `translate3d(${finalX}px, ${finalY}px, 0)`,
    transition: transform ? "none" : "transform 0.2s",
    cursor: draggable ? "grab" : "default",
    color: "white",
    // fontSize: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center",
    borderRadius: 4,
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    userSelect: "none",
    // outline: "2px solid #333", // Add box outline
    border: "1px solid black",
  };

  const [opened_Modal_PCInfo, setOpened_Modal_PCInfo] = useState(false);
  const PCInfoTable = () => {
    let filtered_DB_BoxList = DB_BoxList?.filter((x) => {
      return x?.PC_Name === pc_name;
    })?.[0];

    console.log("DB_BoxList000", filtered_DB_BoxList, pc_name);

    let result = (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 2fr",
          gap: "8px",
          maxWidth: 500,
          border: "1px solid #ccc",
          padding: 1,
          background: "#fafafa",
        }}
      >
        {Object.entries(filtered_DB_BoxList)?.map(([key, value]) => (
          <React.Fragment key={key}>
            <div style={{ fontWeight: "bold", background: "#f0f0f0" }}>
              {key}
            </div>
            <div>{value}</div>
          </React.Fragment>
        ))}
      </div>
    );
    return result;
  };

  const [menuOpened, setMenuOpened] = useState(false);
  const [menuCoords, setMenuCoords] = useState({ x: 0, y: 0 });

  const MENU_WIDTH = 500; // Set this to your menu's minWidth or actual width

  const handleContextMenu = (event) => {
    event.preventDefault(); // Prevent default browser menu
    let x = event.clientX;
    let y = event.clientY;
    // If menu would overflow right, show to the left of cursor
    if (x + MENU_WIDTH > window.innerWidth) {
      x = x - MENU_WIDTH;
      if (x < 0) x = 0; // Prevent negative
    }
    // setMenuCoords({ x: event.clientX, y: event.clientY });
    setMenuCoords({ x, y });
    setMenuOpened(true);
  };

  const handleClose = (temp_bool) => {
    setMenuOpened(temp_bool);
  };

  const itemProps = useRef({
    cafe: selectedPresentationCafe,
    pc_name: pc_name,
    x: position?.x,
    y: position?.y,
    w: w,
    h: h,
    x: x,
    y: y,
    custom_bgcolor: custom_bgcolor,
    pc_hide: pc_hide,
  });

  // ----------------------------------------------- func
  const Update_W = (_new_w, _method = "addon") => {
    console.log(
      `Update_W pre = w:${itemProps.current.w},h:${itemProps.current.h}`,
    );
    itemProps.current.cafe = selectedPresentationCafe;
    itemProps.current.pc_name = pc_name;
    itemProps.current.w = w;
    itemProps.current.h = h;

    if (_method == "addon") {
      let updated_new_w = (itemProps?.current?.w || 0) + _new_w;
      if (updated_new_w <= 0) {
        itemProps.current.w = 5;
      } else {
        itemProps.current.w = updated_new_w;
      }
    } else if (_method == "fixed") {
      itemProps.current.w = _new_w;
    }

    itemProps.current.custom_bgcolor = custom_bgcolor;
    itemProps.current.x = position?.x;
    itemProps.current.y = position?.y;

    console.log(
      `Update_W new = w:${itemProps.current.w},h:${itemProps.current.h}`,
    );

    set_DB_Data_UpdateButtonPos_ByProps(itemProps.current);
  };
  const Update_H = (_new_h, _method = "addon") => {
    console.log(
      `Update_H pre = w:${itemProps.current.w},h:${itemProps.current.h}`,
    );

    itemProps.current.cafe = selectedPresentationCafe;
    itemProps.current.pc_name = pc_name;
    itemProps.current.w = w;
    itemProps.current.h = h;

    if (_method == "addon") {
      let updated_new_h = (itemProps?.current?.h || 0) + _new_h;
      if (updated_new_h <= 0) {
        itemProps.current.h = 5;
      } else {
        itemProps.current.h = updated_new_h;
      }
    } else if (_method == "fixed") {
      itemProps.current.h = _new_h;
    }

    itemProps.current.custom_bgcolor = custom_bgcolor;
    itemProps.current.x = position?.x;
    itemProps.current.y = position?.y;

    console.log(
      `Update_H new = w:${itemProps.current.w},h:${itemProps.current.h}`,
    );
    set_DB_Data_UpdateButtonPos_ByProps(itemProps.current);
  };
  const Update_BG_Color = (new_GB_Color) => {
    // itemProps.current.h = (itemProps?.current?.h || 0) + new_h;

    itemProps.current.pc_name = pc_name;
    itemProps.current.cafe = selectedPresentationCafe;
    itemProps.current.custom_bgcolor = new_GB_Color;
    itemProps.current.x = position?.x;
    itemProps.current.y = position?.y;

    set_DB_Data_UpdateButtonPos_ByProps(itemProps.current);
  };
  const Update_PC_Hide = (new_pc_hide_status) => {
    // itemProps.current.h = (itemProps?.current?.h || 0) + new_h;

    itemProps.current.pc_name = pc_name;
    itemProps.current.cafe = selectedPresentationCafe;
    itemProps.current.pc_hide = new_pc_hide_status;
    itemProps.current.custom_bgcolor = custom_bgcolor;
    itemProps.current.x = 0;
    itemProps.current.y = 0;

    set_DB_Data_UpdateButtonPos_ByProps(itemProps.current);
  };

  const Format_CPU_Name = () => {
    return (
      <div className=" CM_HardwareText_CPU">
        {
          DB_ConfigHardwareList?.filter((x) => {
            return x.ori_hw_name == CPU_Name;
          })?.[0]?.new_hw_name
        }
      </div>
    );
  };

  const Format_RAM_Capacity = () => {
    return (
      <div className=" CM_HardwareText_RAM">
        {(RAM_Capacity ?? "")
          ? `${RAM_Capacity?.split(",")?.[0] / 1024} GB`
          : ""}
      </div>
    );
  };

  const Format_GPU_Name = () => {
    let result = null;

    let data = DB_ConfigHardwareList?.filter((x) => {
      return x.ori_hw_name == GPU_Name;
    })?.[0]?.new_hw_name?.replaceAll("|", "");
    // console.log(`label = ${label}`, label.includes("pc"));
    if (pc_name?.toLowerCase()?.includes("pc")) {
      result = (
        <div className=" CM_TextVerticleHeigh CM_HardwareText_GPU">{data}</div>
      );
    }

    return result;
  };

  const Format_MON_Manufacturer = () => {
    let result = null;

    let filtered_brandName = "";
    let brandModel = "";
    let brandName = DB_ConfigHardwareList?.filter((x) => {
      return x.ori_hw_name == MON_Manufacturer;
    })?.[0]?.new_hw_name;

    if (brandName?.includes("|") === false) {
      filtered_brandName = brandName;
    }

    if (brandName?.includes("|") === true) {
      filtered_brandName = brandName?.split("|")?.[0];
      brandModel = brandName?.split("|")?.[1];
    }

    if (pc_name?.toLowerCase()?.includes("pc")) {
      result = (
        <div className="CM_TextVerticleHeigh CM_HardwareText_MON">
          {/* <div style={{ fontSize: "7px" }}>{filtered_brandName}</div> */}
          <div>{brandModel}</div>
          {/* <div>{brandName}</div> */}
        </div>
      );
    }

    return result;
  };

  const Format_MON_FPS = () => {
    return (
      <div className=" CM_TextVerticleHeigh CM_HardwareText_FPS">
        {(mon_fps ?? "") ? `${mon_fps} Hz` : ""}
      </div>
    );
  };

  const get_CurrentPC_Remark = (_label) => {
    let ressult = DB_BoxList?.filter((x) => x?.zjm === _label)?.[0]
      ?.pc_name_remark;
    // console.log("result", ressult);
    return ressult;
  };

  useEffect(() => {
    // console.log("C_SignalToCloseMenu", C_SignalToCloseMenu);
    handleClose(false);
  }, [C_SignalToCloseMenu]);

  // useEffect(() => {
  // console.log(`DB_ConfigHardwareList ${label}`, DB_ConfigHardwareList);
  // }, [DB_ConfigHardwareList]);

  return (
    <div>
      <div
        ref={setNodeRef}
        style={box_Style}
        className="CM_Box_Container"
        {...(draggable ? attributes : {})}
        {...(draggable ? listeners : {})}
        onContextMenu={handleContextMenu}
      >
        {!isLoading2 ? (
          // Box Render Here
          <div
            style={{
              backgroundColor: isLoading2 ? "lime" : "",
              // borderTop: highlightBGColor(),
            }}
            className="CM_Box_Container_Sub"
          >
            <div className="CM_Box_PCName">
              {pc_name}
              {Offline_Day > 1 && (
                <span className="CM_Offline_Alert"> {Offline_Day}</span>
              )}
            </div>
            {pczone_name != "" ? (
              <div className="CM_Box_PCZone">{`${pczone_name} (${dlip}) `}</div>
            ) : null}
            <div className="CM_Box_PCNameRemark">
              {/* {get_CurrentPC_Remark(pc_name) !== null &&
              get_CurrentPC_Remark(pc_name) !== "" ? (
                <div style={{ color: "lime", backgroundColor: "black" }}>
                  {get_CurrentPC_Remark(pc_name)}
                </div>
              ) : null} */}
            </div>
            <div className="CM_Flex_Col CM_LineHeigh">
              <Format_CPU_Name />
              <Format_RAM_Capacity />
              <Format_GPU_Name />
              <Format_MON_Manufacturer />
              <Format_MON_FPS />
              {/* <button
                onClick={() =>
                  console.log("props", {
                    id,
                    id_b,
                    position,
                    pc_name,
                    custom_bgcolor,
                    draggable,
                    dlip,
                    pczone_name,
                    selectedPresentationCafe,
                    w,
                    h,
                    x,
                    y,
                    pc_hide,
                    setP_RequestReRender,
                    C_SignalToCloseMenu,
                    selectedPCZone,
                    GPU_Name,
                    CPU_Name,
                    MON_Manufacturer,
                    NIC_Speed,
                    RAM_Capacity,
                    mon_fps,
                    selectedPCHW,
                    showCoordinate,
                    DB_ConfigHardwareList,

                    Offline_Day,
                    VT_On,
                    PC_StartUpTime_Sec,
                    MOBO_Product,

                    DB_BoxList,
                    // opened_Modal_PCInfo,
                    // setOpened_Modal_PCInfo,
                  })
                }
              >
                Test
              </button> */}
            </div>
            {showCoordinate ? (
              <div style={{ fontSize: "10px", marginTop: "0px" }}>
                {`(${position?.x}, ${position?.y})`}
              </div>
            ) : null}
          </div>
        ) : (
          "Loading..."
        )}
      </div>
      <Modal
        opened={opened_Modal_PCInfo}
        onClose={() => setOpened_Modal_PCInfo(false)}
        title="opened_PCInfo"
        fullScreen
        closeOnEscape
        zIndex="9999"
      >
        <PCInfoTable />
      </Modal>
      {menuOpened && draggable && (
        <div
          style={{
            position: "fixed",
            top: menuCoords.y,
            left: menuCoords.x,
            zIndex: 9999,
            minWidth: 120,
            fontSize: 12,
            padding: 0,
          }}
          // onClick={handleClose}
        >
          <Menu
            opened={true}
            onClose={() => {
              handleClose(false);
            }}
            withinPortal={false}
            // closeOnClickOutside={true}
            // closeOnEscape={true}

            styles={{
              dropdown: { padding: 4, minWidth: 120 },
              item: { padding: "2px 8px", fontSize: 12, minHeight: 24 },
              label: { fontSize: 11, padding: "2px 8px" },
            }}
          >
            <Menu.Dropdown className="CM_DropdownMenu_Container">
              {/* ------------------ close & prop */}

              <div className="CM_PopMenu_Grid">
                <Button
                  size="xs"
                  variant="filled"
                  color="red"
                  onClick={() => {
                    handleClose(false);
                  }}
                >
                  Close
                </Button>
                <div className="CM_Flex_Row">
                  <Button
                    size="xs"
                    variant="subtle"
                    color="blue"
                    onClick={() => {
                      itemProps.current.w = w;
                      itemProps.current.h = h;
                      console.log("itemProps", itemProps.current);
                      handleClose(false);
                    }}
                  >
                    <span>{`Actions : ${pc_name} - ${pczone_name} (${dlip}) x:${x},y:${y},w${w} x h${h}`}</span>
                  </Button>
                  <Button
                    disabled={!pc_name?.toLowerCase()?.includes("pc")}
                    size="xs"
                    variant="subtle"
                    color="gray"
                    onClick={() => {
                      setOpened_Modal_PCInfo(true);
                      // setP_RequestReRender("s");
                      console.log("ss");
                    }}
                  >
                    Show PC Details Info
                  </Button>
                </div>
              </div>
              {/* ------------------ Width */}
              <hr />
              <div className="CM_PopMenu_Grid">
                <div> Width ⮜⮞</div>
                <div className="CM_Flex_Row">
                  <Button
                    size="xs"
                    variant="outline"
                    color="red"
                    onClick={() => {
                      Update_W(-20);
                    }}
                  >
                    -20
                  </Button>

                  <Button
                    size="xs"
                    variant="outline"
                    color="blue"
                    onClick={() => {
                      Update_W(20);
                    }}
                  >
                    +20
                  </Button>
                  <hr />

                  <NumberInput
                    hideControls
                    max={2000}
                    min={0}
                    // label={`Change Name: from : ${label}, to : ${selected_ChangePCName}`}
                    // style={{ width: "100px" }}
                    placeholder="new Width"
                    onChange={(e) => {
                      setSelected_New_W(e);
                    }}
                  />
                  <Button
                    size="xs"
                    variant="filled"
                    color="lime"
                    onClick={() => {
                      console.log("selected_New_W", selected_New_W);
                      Update_W(selected_New_W, "fixed");
                    }}
                  >
                    Change
                  </Button>
                </div>
              </div>

              {/* ------------------ Height */}
              <div className="CM_PopMenu_Grid">
                <div>Height ⮝⮟</div>
                <div className="CM_Flex_Row">
                  <Button
                    size="xs"
                    variant="outline"
                    color="red"
                    onClick={() => {
                      Update_H(-20);
                    }}
                  >
                    -20
                  </Button>

                  <Button
                    size="xs"
                    variant="outline"
                    color="blue"
                    onClick={() => {
                      Update_H(20);
                    }}
                  >
                    +20
                  </Button>
                  <hr />

                  <NumberInput
                    hideControls
                    max={2000}
                    min={0}
                    // label={`Change Name: from : ${label}, to : ${selected_ChangePCName}`}
                    // style={{ width: "100px" }}
                    placeholder="new Height"
                    onChange={(e) => {
                      setSelected_New_H(e);
                    }}
                  />
                  <Button
                    size="xs"
                    variant="filled"
                    color="lime"
                    onClick={() => {
                      console.log("selected_New_H", selected_New_H);
                      Update_H(selected_New_H, "fixed");
                    }}
                  >
                    Change
                  </Button>
                </div>
              </div>
              {/* ------------------ Height */}
              <div className="CM_PopMenu_Grid">
                <div
                  style={{
                    minWidth: "100px",
                    color: "white",
                    backgroundColor: custom_bgcolor,
                  }}
                >
                  Color
                </div>
                <div className="CM_Flex_Row">
                  <ColorPicker
                    format="hex"
                    withPicker={false}
                    swatches={[
                      "#FF5733", // Red-Orange
                      "#FF8C00", // Dark Orange
                      "#FFD700", // Gold
                      "#FFC300", // Saffron
                      "#FF69B4", // Pink
                      "#B22222", // Firebrick
                      "#FFA500", // Orange
                      "#ADFF2F", // GreenYellow
                      "#32CD32", // LimeGreen
                      "#228B22", // ForestGreen
                      "#00FF7F", // SpringGreen
                      "#40E0D0", // Turquoise
                      "#1E90FF", // DodgerBlue
                      "#6495ED", // CornflowerBlue
                      "#483D8B", // DarkSlateBlue
                      "#8A2BE2", // BlueViolet
                      "#9932CC", // DarkOrchid
                      "#000000", // Black
                      "#FFFFFF", // White
                      "#808080", // Gray
                    ]}
                    onChange={(e) => {
                      console.log("e", e);
                      Update_BG_Color(e);
                    }}
                  />
                  <hr />
                  <Button
                    color="orange"
                    variant="subtle"
                    onClick={() => {
                      set_DB_Data_CafeBox_Def_gbColor(
                        selectedPresentationCafe,
                        pc_name,
                      );
                    }}
                  >
                    RESET DEFAULT
                  </Button>
                </div>
              </div>
              <hr />
              {/* ------------------ hidden */}
              <div className="CM_PopMenu_Grid">
                <div>This PC</div>
                <div className="CM_Flex_Row">
                  <Button
                    disabled={pc_hide == 1}
                    size="xs"
                    variant="outline"
                    color="red"
                    onClick={() => {
                      Update_PC_Hide(1);
                      handleClose(false);
                      // setItemProps((prev) => ({
                      //   ...prev,
                      //   pc_hide: 1,
                      // }));
                    }}
                  >
                    Hide
                  </Button>
                  <Button
                    disabled={pc_hide == 0}
                    size="xs"
                    variant="outline"
                    color="blue"
                    onClick={() => {
                      Update_PC_Hide(0);
                      handleClose(false);
                      // setItemProps((prev) => ({
                      //   ...prev,
                      //   pc_hide: 0,
                      // }));
                    }}
                  >
                    Unhide
                  </Button>
                </div>
              </div>
              {/* ------------------ change box name */}
              <div className="CM_PopMenu_Grid">
                <div>Change Name</div>
                <div className="CM_Flex_Row">
                  <hr />
                  <TextInput
                    disabled={pc_name?.toLowerCase()?.includes("pc")}
                    // label={`Change Name: from : ${label}, to : ${selected_ChangePCName}`}
                    // style={{ width: "100px" }}
                    placeholder="new Box Name"
                    onChange={(e) => {
                      setSelected_ChangePCName(e.currentTarget.value);
                    }}
                  />
                  <Button
                    disabled={pc_name?.toLowerCase()?.includes("pc")}
                    size="xs"
                    variant="filled"
                    color="lime"
                    onClick={() => {
                      // Update_PC_Hide(0);
                      if (
                        window.confirm(`
                      Confirm Update in '${selectedPresentationCafe}' 
                      
                      from : ${pc_name}
                      to   : ${selected_ChangePCName}
                      `)
                      ) {
                        console.log(
                          "selected_ChangePCName",
                          selectedPresentationCafe,
                          pc_name,
                          selected_ChangePCName,
                        );
                        set_DB_Data_BoxName(
                          selectedPresentationCafe,
                          pc_name,
                          selected_ChangePCName,
                        );
                      }
                    }}
                  >
                    Change
                  </Button>
                </div>
              </div>
              {/* ------------------ pc remark */}
              <div className="CM_PopMenu_Grid">
                <div>
                  <div>PC Remark </div>
                  <div className="CM_Flex_Row" style={{ marginLeft: "1rem" }}>
                    <div>{`Current : `}</div>
                    <div
                      className="CM_Flex_Row"
                      style={{
                        color: "lime",
                        backgroundColor: "black",
                        paddingLeft: "1rem",
                        paddingRight: "1rem",
                      }}
                    >
                      {get_CurrentPC_Remark(pc_name)}
                    </div>
                    {get_CurrentPC_Remark(pc_name) !== null &&
                    get_CurrentPC_Remark(pc_name) !== "" ? (
                      <Button
                        color="red"
                        variant="subtle"
                        onClick={() => {
                          // Update_PC_Hide(0);
                          if (
                            window.confirm(`
                      Confirm Remove Remark in '${selectedPresentationCafe}' 
                      
                      from : ${get_CurrentPC_Remark(pc_name)}
                      to   : EMPTY
                      `)
                          ) {
                            console.log(
                              "selected_PCRemark",
                              selectedPresentationCafe,
                              pc_name, //pc name
                              selected_PCRemark,
                              // DB_BoxList?.filter((x) => {
                              //   return x?.zjm === label;
                              // })?.pc_name_remark
                            );
                            set_DB_Data_PCRemark(
                              selectedPresentationCafe,
                              pc_name,
                              "",
                            );
                          }
                        }}
                      >
                        Clear
                      </Button>
                    ) : null}
                  </div>
                </div>

                <div className="CM_Flex_Row">
                  <hr />
                  <TextInput
                    disabled={!pc_name?.toLowerCase()?.includes("pc")}
                    // label={}
                    // style={{ width: "100px" }}
                    placeholder="PC Remark"
                    onChange={(e) => {
                      setSelected_PCRemark(e.currentTarget.value);
                    }}
                  />
                  <Button
                    disabled={!pc_name?.toLowerCase()?.includes("pc")}
                    size="xs"
                    variant="filled"
                    color="lime"
                    onClick={() => {
                      // Update_PC_Hide(0);
                      if (
                        window.confirm(`
                      Confirm Update in '${selectedPresentationCafe}' 
                      
                      from : ${get_CurrentPC_Remark(pc_name)}
                      to   : ${selected_PCRemark}
                      `)
                      ) {
                        console.log(
                          "selected_PCRemark",
                          selectedPresentationCafe,
                          pc_name, //pc name
                          selected_PCRemark,
                          // DB_BoxList?.filter((x) => {
                          //   return x?.zjm === label;
                          // })?.pc_name_remark
                        );
                        set_DB_Data_PCRemark(
                          selectedPresentationCafe,
                          pc_name,
                          selected_PCRemark,
                        );
                      }
                    }}
                  >
                    Change
                  </Button>
                </div>
              </div>
              {/* ------------------ remove box */}
              <div className="CM_PopMenu_Grid">
                <div> Remove</div>
                <div className="CM_Flex_Row">
                  <Button
                    disabled={pc_name?.toLowerCase()?.includes("pc")}
                    size="xs"
                    variant="subtle"
                    color="red"
                    onClick={() => {
                      // Update_PC_Hide(0);
                      if (
                        window.confirm(`
                      *** Noted : Delete Box here will not affect the real pc list
                      *** Safe to Deleted
                      
                        Confirm Delete in '${selectedPresentationCafe}' 
                      
                      Box Name : ${pc_name} 
                      `)
                      ) {
                        console.log(
                          "selected_ChangePCName",
                          selectedPresentationCafe,
                          pc_name,
                        );
                        del_DB_Data_BoxName(selectedPresentationCafe, pc_name);
                      }
                    }}
                  >
                    {`Delete '${pc_name}' Box`}
                  </Button>
                </div>
              </div>
            </Menu.Dropdown>
          </Menu>
        </div>
      )}
    </div>
  );
}

export default function App({ selectedPresentationCafe }) {
  const [DB_BoxList, setDB_BoxList] = useState([
    {
      id: "PC01",
      zjm: "PC01",
      pczone_name: "High",
      dlip: "D",
      cafe: "Gift SGBuloh",
      cafe_b: "Gift SGBuloh",
      zjm_b: "PC01",
      custom_bgcolor: "gold",
      x: 0,
      y: 0,
      pc_hide_b: 0,
      w: 50,
      h: 100,
    },
    {
      id: "PC02",
      zjm: "PC02",
      pczone_name: "High",
      dlip: "D",
      cafe: "Gift SGBuloh",
      cafe_b: "Gift SGBuloh",
      zjm_b: "PC02",
      custom_bgcolor: "gold",
      x: 0,
      y: 0,
      pc_hide_b: 0,
      w: 100,
      h: 50,
    },
  ]);
  // const [DB_BoxList_Copy, setDB_BoxList_Copy] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const get_DB_Data = async (cafe) => {
    // setLoadTask1(0);

    await axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/get_eclipse_pos_cafepc_customlist_fordnd`,
        {
          cafe,
          pc_hide_b: showHiddenItem,
        },
      )
      .then((res) => {
        setIsLoading(true);
        console.log("get_DB_Data", res?.data);

        setDB_BoxList(res?.data);
        // setDB_BoxList_Copy(res?.data);

        setIsLoading(false);
      });
  };

  const set_DB_Data_UpdateButtonPos_ByCafePCXY = async (cafe, pc, x, y) => {
    console.log("set_DB_Data_UpdateButtonPos_ByCafePCXY", cafe, pc, x, y);

    setIsLoading(true);

    await axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/set_eclipse_pos_cafepc_customlist_bycafepc`,
        {
          cafe,
          pc,
          x,
          y,
        },
      )
      .then((res) => {
        console.log("set_DB_Data_UpdateButtonPos_ByCafePCXY", res?.data);
        get_DB_Data(selectedPresentationCafe);

        setIsLoading(false);
      });
  };

  const [DB_ConfigHardwareList, setDB_ConfigHardwareList] = useState([]);
  const get_DB_Data_ConfiHardware = async () => {
    // setLoadTask1(0);

    await axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/get_eclipse_pos__confi_hardware__all`, {})
      .then((res) => {
        console.log("get_DB_Data_ConfiHardware", res?.data);

        setDB_ConfigHardwareList(res?.data);
      });
  };

  const add_DB_Data_NewBox = async (cafe, boxName) => {
    // setLoadTask1(0);

    await axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/add_eclipse_pos__newultilitybox`, {
        cafe,
        boxName,
      })
      .then((res) => {
        let result = res?.data;
        console.log("add_DB_Data_NewBox", result);
        if (result?.affectedRows > 0) {
          setSelectedNewBoxName("");
          // reload map
          get_DB_Data(selectedPresentationCafe);
          alert(`
            Added Successfully

            cafe = ${cafe}
            boxName = ${boxName}

            `);
        }
      });
  };

  const sensors = useSensors(useSensor(PointerSensor));

  // const initialBoxList = [
  //   { id: "PC01", zjm_b: "PC01", x: 100, y: 0, custom_bgcolor: "tomato" },
  //   { id: "PC02", zjm_b: "PC02", x: 100, y: 0, custom_bgcolor: "steelblue" },
  //   { id: "PC03", zjm_b: "PC03", x: 300, y: 0, custom_bgcolor: "seagreen" },
  //   { id: "PC04", zjm_b: "PC04", x: 400, y: 0, custom_bgcolor: "goldenrod" },
  //   { id: "PC05", zjm_b: "PC05", x: 500, y: 0, custom_bgcolor: "purple" },
  //   { id: "PC06", zjm_b: "PC06", x: 100, y: 200, custom_bgcolor: "crimson" },
  //   { id: "PC07", zjm_b: "PC07", x: 200, y: 200, custom_bgcolor: "teal" },
  //   { id: "PC08", zjm_b: "PC08", x: 300, y: 200, custom_bgcolor: "orange" },
  //   { id: "PC09", zjm_b: "PC09", x: 400, y: 200, custom_bgcolor: "dodgerblue" },
  //   {
  //     id: "PC10",
  //     zjm_b: "PC10",
  //     x: 500,
  //     y: 200,
  //     custom_bgcolor: "mediumslateblue",
  //   },
  // ];

  // const [positions, setPositions] = useState(() => {
  //   const posObj = {};
  //   initialBoxList.forEach(({ id, x, y }) => {
  //     posObj[id] = { x, y };
  //   });
  //   return posObj;
  // });
  function getPositionsFromBoxList(boxList) {
    const posObj = {};
    boxList.forEach(({ id, x, y }) => {
      posObj[id] = { x, y };
    });
    return posObj;
  }
  const [positions, setPositions] = useState(() =>
    getPositionsFromBoxList(DB_BoxList),
  );
  useEffect(() => {
    setPositions(getPositionsFromBoxList(DB_BoxList));
  }, [DB_BoxList]);

  const [editable, setEditable] = useState(false); // devMode : false
  const [showHiddenItem, setShowHiddenItem] = useState(0);
  const [showCoordinate, setShowCoordinate] = useState(0);

  const handleDragEnd = ({ active, delta }) => {
    if (!editable) return; // Ignore if dragging disabled

    const id = active.id;
    const prev = positions[id];
    const updated = snapToGrid(prev.x + delta.x, prev.y + delta.y);

    // If new position is negative or exceeds 1600, do not update position (box will "snap back")
    if (
      updated.x < 0 ||
      updated.y < 0 ||
      updated.x > 1800 - 100 || // Map Actual Edit Size
      updated.y > 1300 - 100 // Map Actual Edit Size
    ) {
      // Optionally, you can show a message or visual feedback here
      return;
    }

    setPositions((prev) => ({
      ...prev,
      [id]: updated,
    }));

    handleBoxMoved(id, updated);
  };

  function handleBoxMoved(id, position) {
    let thisButtonInfo = DB_BoxList?.filter((x) => {
      return x.zjm_b == id;
    })?.[0];
    console.log("thisButtonInfo", thisButtonInfo);
    console.log(`Box ${id} dropped at (${position.x}, ${position.y})`);
    set_DB_Data_UpdateButtonPos_ByCafePCXY(
      selectedPresentationCafe,
      //thisButtonInfo?.cafe,
      thisButtonInfo?.zjm_b,
      Math.abs(position?.x),
      Math.abs(position?.y),
    );
  }

  const [P_RequestReRender, setP_RequestReRender] = useState(0);
  const [C_SignalToCloseMenu, setC_SignalToCloseMenu] = useState(0);

  const [selectedPCZone, setSelectedPCZone] = useState("");
  const [selectedPCHW, setSelectedPCHW] = useState("");

  const [mapZoomSize, setMapZoomSize] = useState("0.67");

  const [selectedNewBoxName, setSelectedNewBoxName] = useState("");

  useEffect(() => {
    if (selectedPresentationCafe !== "") {
      get_DB_Data(selectedPresentationCafe);
      get_DB_Data_ConfiHardware();
    }
    console.log("useEffect get_DB_Data");
  }, [selectedPresentationCafe, showHiddenItem, P_RequestReRender]);

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
        <Checkbox
          checked={editable}
          onChange={(event) => setEditable(event.currentTarget.checked)}
          label={<div style={{ color: "white" }}>Editable</div>}
        />
        <Checkbox
          checked={showHiddenItem}
          onChange={(event) => setShowHiddenItem(+event.currentTarget.checked)}
          label={<div style={{ color: "white" }}>Show Hidden Item</div>}
        />
        <Checkbox
          checked={showCoordinate}
          onChange={(event) => setShowCoordinate(event.currentTarget.checked)}
          label={<div style={{ color: "white" }}>Show XY </div>}
        />

        <Radio.Group
          value={mapZoomSize}
          onChange={(e) => {
            console.log("e", e);
            setMapZoomSize(e);
          }}
        >
          <Radio
            value={"1.2"}
            label={<div style={{ color: "white" }}>120%</div>}
          />
          <Radio
            value={"1"}
            label={<div style={{ color: "white" }}>100%</div>}
          />
          <Radio
            value={"0.8"}
            label={<div style={{ color: "white" }}>80%</div>}
          />
          <Radio
            value={"0.67"}
            label={<div style={{ color: "white" }}>67%</div>}
          />
          <Radio
            value={"0.2"}
            label={<div style={{ color: "white" }}>20%</div>}
          />
        </Radio.Group>

        <TextInput
          value={selectedNewBoxName}
          onChange={(e) => {
            setSelectedNewBoxName(e.currentTarget.value);
          }}
        />
        <Button
          color="lime"
          onClick={() => {
            if (window.confirm(`Add New Box : ${selectedNewBoxName} ? `)) {
              console.log("selectedNewBoxName", selectedNewBoxName);
              add_DB_Data_NewBox(selectedPresentationCafe, selectedNewBoxName);
            }
          }}
        >
          Add New Box
        </Button>
      </div>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            // width: "100%",
          }}
        >
          {/* <Comp_Legend_PCZone
              cafename={selectedPresentationCafe}
              setSelectedPCZone={setSelectedPCZone}
            /> */}
          <Comp_Legend_PCHW
            cafename={selectedPresentationCafe}
            selectedPCHW={selectedPCHW}
            setSelectedPCHW={setSelectedPCHW}
          />
        </div>
      </div>
      <b>
        *** the pc hardware list here is depeding on the b3mon within 100days
        data, if not showing here try open the pc and login acc, then wait 60sec
        for the api backend to make the expensive caching task, then will show
        later
      </b>
      <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
        <div
          style={{
            position: "relative",
            padding: 20,
            backgroundColor: "transparent",
            padding: "1rem",
            borderRadius: "1rem",
            width: "1900px", // Map Edit Size
            height: "1400px", // Map Edit Size
            zoom: mapZoomSize, // Set map zoom
          }}
        >
          <div
            style={{
              position: "relative",
              padding: 20,
              backgroundColor: "gray",
              padding: "1rem",
              borderRadius: "1rem",
              width: "1800px", // Map Actual Edit Size
              height: "1300px", // Map Actual Edit Size
            }}
            onClick={() => {
              // setC_SignalToCloseMenu(Math.random());
              // console.log("Clicked on background");
            }}
          >
            <DndContext sensors={sensors} onDragEnd={handleDragEnd}>
              {DB_BoxList?.map(
                (
                  {
                    id,
                    id_b,
                    zjm_b,
                    dlip,
                    pczone_name,
                    custom_bgcolor,
                    w,
                    h,
                    x,
                    y,
                    pc_hide_b,
                    GPU_Name,
                    CPU_Name,
                    MON_Manufacturer,
                    NIC_Speed,
                    RAM_Capacity,
                    mon_fps,

                    Offline_Day,
                    VT_On,
                    PC_StartUpTime_Sec,
                    MOBO_Product,

                    // opened_Modal_PCInfo,
                    // setOpened_Modal_PCInfo,
                  },
                  i,
                ) => {
                  return (
                    <DraggableBox
                      key={i}
                      id={id}
                      id_b={id_b}
                      pc_name={zjm_b}
                      custom_bgcolor={isLoading ? "black" : custom_bgcolor}
                      position={positions[id]}
                      draggable={editable}
                      dlip={dlip}
                      pczone_name={pczone_name}
                      selectedPresentationCafe={selectedPresentationCafe}
                      w={w}
                      h={h}
                      x={x}
                      y={y}
                      pc_hide={pc_hide_b}
                      setP_RequestReRender={setP_RequestReRender}
                      C_SignalToCloseMenu={C_SignalToCloseMenu}
                      selectedPCZone={selectedPCZone}
                      GPU_Name={GPU_Name}
                      CPU_Name={CPU_Name}
                      MON_Manufacturer={MON_Manufacturer}
                      NIC_Speed={NIC_Speed}
                      RAM_Capacity={RAM_Capacity}
                      mon_fps={mon_fps}
                      selectedPCHW={selectedPCHW}
                      showCoordinate={showCoordinate}
                      DB_ConfigHardwareList={DB_ConfigHardwareList}
                      Offline_Day={Offline_Day}
                      VT_On={VT_On}
                      PC_StartUpTime_Sec={PC_StartUpTime_Sec}
                      MOBO_Product={MOBO_Product}
                      DB_BoxList={DB_BoxList}
                      // opened_Modal_PCInfo={opened_Modal_PCInfo}
                      // setOpened_Modal_PCInfo={setOpened_Modal_PCInfo}
                    />
                  );
                },
              )}
            </DndContext>
          </div>
        </div>
      </div>
    </div>
  );
}
